import React, { useCallback, useContext, useState } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { EXPORT_PDF } from '../../../report-actions/constants';
import { ReportsContext } from '../../../context';
import { Button } from 'ui-components/components/button';
import { Checkbox } from 'ui-components/components/checkbox';
import { TooltipPosition } from 'ui-components/components/tooltip/tooltip-position';
import BarcodeSelector from './barcode-selector';
import BarcodeScanScheet from './barcodescansheet.png';
import { useBarcodeScanningFeatureGate } from '../../../../../../../feature-gates/use-barcode-scanning-feature-gate';
import { FeatureGatedPromotionalBanner } from '../../../../../../../feature-gates/feature-gated-promotional-banner';

import buttonMessages from '../messages';
import messages from './messages';
import inputsStyle from '../../../report-filters/style.module.less';
import style from '../style.module.less';

const BarcodeScanQuickReference = () => {
  const totalAllowedBarcodes = 10;
  const { handleBarcodeRequest } = useContext(ReportsContext);
  const [selectedBarcodes, setSelectedBarcodes] = useState([]);
  const [includeHotkeys, setIncludeHotkeys] = useState(false);

  const { isFeatureEnabled, disabledMessage } = useBarcodeScanningFeatureGate();

  const runReportOverride = useCallback(() => {
    if (!selectedBarcodes.length) {
      return;
    }
    handleBarcodeRequest({
      shouldShowHotkeys: includeHotkeys,
      barcodes: selectedBarcodes,
    });
    setSelectedBarcodes([]);
  }, [handleBarcodeRequest, selectedBarcodes, includeHotkeys]);

  const onBarcodeSelected = useCallback(
    ({ ordinalPosition, barcode }) => {
      if (!barcode || selectedBarcodes.map((code) => code.barcodeContent).includes(barcode.barcodeContent)) {
        return;
      }
      if (ordinalPosition > selectedBarcodes.length - 1) {
        const allBarcodes = [...selectedBarcodes, barcode];
        setSelectedBarcodes(allBarcodes);
        return;
      }
      selectedBarcodes[ordinalPosition] = barcode;
      const allBarcodes = [...selectedBarcodes];
      setSelectedBarcodes(allBarcodes);
    },
    [selectedBarcodes],
  );

  return (
    <>
      {!isFeatureEnabled && <FeatureGatedPromotionalBanner className={style.banner} />}
      <div className={style['barcode-scan-quickref']}>
        <div>
          <div className={classnames(style.filters, style['barcode-selectors'])}>
            {new Array(totalAllowedBarcodes).fill(true).map((_, iteratorCount) => {
              return (
                <BarcodeSelector
                  key={iteratorCount}
                  disabled={iteratorCount > selectedBarcodes.length}
                  onBarcodeSelected={onBarcodeSelected}
                  ordinalPosition={iteratorCount}
                  selectedBarcodeName={selectedBarcodes[iteratorCount]?.name}
                />
              );
            })}
            <div className={inputsStyle['filter-input']}>
              <label>
                <FormattedMessage {...messages.shouldShowHotkeysLabel} />
              </label>
              <Checkbox
                checked={includeHotkeys}
                className={inputsStyle['filter-checkbox']}
                disabled={!isFeatureEnabled}
                label={<FormattedMessage {...messages.shouldShowHotkeysText} />}
                onChange={setIncludeHotkeys}
              />
            </div>
          </div>
          <div className={classnames(style['hotkey-action-buttons'], style['quick-reference'])}>
            <Button
              disabled={!isFeatureEnabled}
              disabledTooltipMessage={disabledMessage && <FormattedMessage {...disabledMessage} />}
              disabledTooltipMessagePosition={TooltipPosition.Right}
              onClick={() => runReportOverride(EXPORT_PDF)}
              theme='primary'
            >
              <FormattedMessage {...buttonMessages.exportDirectlyToPdf} />
            </Button>
          </div>
        </div>
        <div className={style['hotkey-report-example']}>
          <img alt='barcodescansheet.png' src={BarcodeScanScheet} />
        </div>
      </div>
    </>
  );
};

export default BarcodeScanQuickReference;
